import { render, staticRenderFns } from "./Lgx241881593226985472.vue?vue&type=template&id=a74023ae&scoped=true&"
import script from "./Lgx241881593226985472.vue?vue&type=script&lang=js&"
export * from "./Lgx241881593226985472.vue?vue&type=script&lang=js&"
import style0 from "./Lgx241881593226985472.vue?vue&type=style&index=0&id=a74023ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74023ae",
  null
  
)

export default component.exports